__webpack_require__.p = "/wp-content/themes/qadeem_theme/assets/";